import { Component } from '@angular/core';
import { RepositoryService } from '../../../smoothr-web-app-core/services/repository/repository.service';
import { ModalController } from '@ionic/angular';
import { MatSnackBar } from '@angular/material/snack-bar';
import RepositoryDirective from '../../../smoothr-web-app-core/directives/repository-directive';
import { TranslateService } from '@ngx-translate/core';
import { environment } from '../../../environments/environment';
import { NavigationService } from 'src/app/services/navigation.service';
import {HelloAgainService} from '../../services/hello-again.service';
import { BrowserLanguageService } from '../../services/geo-language.service';
enum Language {
	GreatBritain = 'en',
	German = 'de',
}

@Component({
	selector: 'app-menu-modal',
	templateUrl: './menu-modal.component.html',
	styleUrls: ['./menu-modal.component.scss'],
})
export class MenuModalComponent extends RepositoryDirective {
	environment = environment;
	languageEnum = Language;
	loadingHelloAgain = false;
	constructor(
		public repository: RepositoryService,
		private modalController: ModalController,
		private snackbarCtrl: MatSnackBar,
		public translate: TranslateService,
		private navigationService: NavigationService,
		private helloAgainService: HelloAgainService,
		private browserLanguageService: BrowserLanguageService
	) {
		super(repository);
		this.repository.customerAuth.subscribe();
	}
	ngOnInit(): void {
		super.ngOnInit();
		this.repository.reloadCustomer();
	}
	onCustomer(): void {
		console.log(this.customer);
	}
	async signIn() {
		try {
			await this.modalController.dismiss();
			// await this.modalController.dismiss();
			// await this.navigationService.signIn();
			this.helloAgain();
		} catch (e) {
			// await this.navigationService.signIn();
		}
	}
	async helloAgain() {
		if (!this.loadingHelloAgain) {
			// const result = await BannerInfoComponent.show(this.modalController);
			// if (result?.isNext) {
			this.loadingHelloAgain = true;
			await this.helloAgainService.runUserAuthorization();
			this.loadingHelloAgain = false;
			// }
		}
	}
	async signUp() {
		try {
			await this.modalController.dismiss();
			await this.modalController.dismiss();
			await this.navigationService.signUp();
		} catch (e) {
			await this.navigationService.signUp();
		}
	}

	async mySpace() {
		try {
			await this.modalController.dismiss();
			await this.modalController.dismiss();
			await this.navigationService.account();
		} catch (e) {
			await this.navigationService.account();
		}
	}

	async myOrders() {
		try {
			await this.modalController.dismiss();
			await this.modalController.dismiss();

			await this.navigationService.myOrders();
		} catch (e) {
			await this.navigationService.myOrders();
		}
	}

	async logout() {
		try {
			this.repository.customerAuth.emit(null);
			this.snackbarCtrl.open(this.translate.instant('menu_popover.logout_success'), null, {
				duration: 2000,
			});
		} catch (e) {
			this.snackbarCtrl.open(this.translate.instant('menu_popover.logout_error'), null, {
				duration: 2000,
			});
		}
		await this.modalController.dismiss();
	}

	async home() {
		await this.modalController.dismiss();
		await this.navigationService.home();
	}

	async privacy() {
		try {
			await this.modalController.dismiss();
			await this.modalController.dismiss();
			await this.navigationService.privacy();
		} catch (e) {
			await this.navigationService.privacy();
		}
	}

	async tos() {
		await this.modalController.dismiss();
		try {
			await this.modalController.dismiss();
			await this.modalController.dismiss();
			await this.navigationService.tos();
		} catch (e) {
			await this.navigationService.tos();
		}
	}

	async accessibility() {
		await this.modalController.dismiss();
		try {
			await this.modalController.dismiss();
			await this.modalController.dismiss();
			await this.navigationService.accessibility();
		} catch (e) {
			await this.navigationService.accessibility();
		}
	}

	async impressum() {
		try {
			await this.modalController.dismiss();
			await this.modalController.dismiss();
			await this.navigationService.imprint();
		} catch (e) {
			await this.navigationService.imprint();
		}
	}
	get allergensPdfUrl(): string {
		switch (this.translate.currentLang) {
			case Language.German:
				return '/assets/allergens_de.pdf';
			case Language.GreatBritain:
			default:
				return '/assets/allergens_en.pdf';
		}
	}

	dismiss() {
		this.modalController.dismiss();
	}
	changeLang(language: string) {
		this.browserLanguageService.changeLanguage(language);
	}
}
